import { render, staticRenderFns } from "./ResetarSenhaUsuario.vue?vue&type=template&id=142f301c&scoped=true"
import script from "./ResetarSenhaUsuario.vue?vue&type=script&lang=js"
export * from "./ResetarSenhaUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f301c",
  null
  
)

export default component.exports